import React from "react";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers";

import Img from "@components/FileServer/Img";

import { changeLanguage } from "./SetLanguage";

const DEFAULT_LANGUAGE_ICON_SRC = "/static/images/ico-lang-na.svg";

function SetLanguage(): React.ReactElement {
  const supportedLanguages = useSelector(
    (state: AppState) => state.requestorConfig.supportedLanguages
  );
  return (
    <>
      {supportedLanguages
        .map(({ Language }) => Language)
        .map((language) => (
          <button
            type="button"
            key={language}
            className="header-mobile-menu-link"
            onClick={(e) => {
              e.stopPropagation();
              changeLanguage(language);
            }}
          >
            <Img
              className="header-menu-currency-option-ico"
              src={`/static/images/ico-lang-${language.toLowerCase()}.svg`}
              onError={(e) => {
                e.target.src = DEFAULT_LANGUAGE_ICON_SRC;
              }}
            />
            {language.toUpperCase()}
          </button>
        ))}
    </>
  );
}

export default SetLanguage;
